import { Badge } from '@mui/material';

const DynamicColorBadge = ({ content, color, children }) => {
  return (
    <Badge
      badgeContent={content}
      sx={theme => {
        const paletteColor = theme.palette[color];
        const badgeColor = paletteColor ? paletteColor.main : color;
        return {
          '& .MuiBadge-badge': {
            backgroundColor: badgeColor,
            color: theme.palette.common.white,
            fontWeight: 'bold',
            borderRadius: '12px',
            padding: '0 8px',
          }
        };
      }}
    >
      {children}
    </Badge>
  );
}

export default DynamicColorBadge